import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const AgendaApi = createApi({
  reducerPath: "AgendaApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["Agenda"],
  endpoints: (builder) => ({
    createAgenda: builder.mutation({
      query: (sessionId) => ({
        url: "/agenda",
        method: "POST",
        body: sessionId
      }),
      invalidatesTags: ["Agenda"]
    }),
    getAgendaById: builder.query({
      query: (agendaId) => ({
        url: `/agenda/${agendaId}`,
        method: "GET",
        headers: {
          "x-muse-request-id": "RQ1234567890"
        }
      }),
      providesTags: ["Agenda"]
    }),
    validateAgenda: builder.mutation({
      query: (id) => ({
        url: `/agenda/validate/${id}`,
        method: "GET"
      })
    }),
    updateAgenda: builder.mutation({
      query: (payload) => ({
        url: `/agenda/${payload?.id}`,
        method: "POST",
        body: payload.body
      }),
      invalidatesTags: ["Agenda"]
    }),
    updateutilsAgenda: builder.mutation({
      query: (data) => ({
        url: `/admin/agenda`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Agenda"]
    }),
    getAllAgendasBySessionIdApi: builder.query({
      query: (sessionId) => ({
        url: `/agenda/all/${sessionId}`,
        method: "GET"
      }),
      providesTags: ["Agenda"]
    }),
    deleteAgenda: builder.mutation({
      query: (agenda) => ({
        url: `/agenda/delete/${agenda.id}`,
        method: "DELETE"
      })
    }),
    deleteAgendaById: builder.mutation({
      query: ({
        id,
        action,
        remarks,
        sendRemarksToEducators,
        sendRemarksToCandidates
      }) => ({
        url: `/agenda/cancel/${id}`,
        method: "POST",
        body: {
          action,
          remarks,
          sendRemarksToCandidates,
          sendRemarksToEducators
        }
      }),
      invalidatesTags: ["Agenda"]
    }),
    cloneAgenda: builder.query({
      query: (agendaId) => ({
        url: `/agenda/clone/${agendaId}`,
        method: "GET"
      })
    }),
    cloneAgendaPost: builder.mutation({
      query: ({ data }: any) => ({
        url: `/agenda/cloneWithDelta`,
        method: "POST",
        body: data
      })
    }),
    rescheduleAgenda: builder.mutation({
      query: ({ id, data }: any) => ({
        url: `/agenda/reschedule/${id}`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Agenda"]
    }),
    retriggerEmail: builder.mutation({
      query: ({ eventId, actionType }: any) => ({
        url: `/admin/retrigger/cal-invite/${eventId}/${actionType}`,
        method: "POST"
        // body: data,
      }),
      invalidatesTags: ["Agenda"]
    }),
    createAgendaPostPublish: builder.mutation({
      query: (payload) => ({
        url: `/agenda/extend/add-agenda/${payload.eventId}?sendNotification=false`,
        method: "POST",
        body: payload.body
      }),
      invalidatesTags: ["Agenda"]
    })
  })
});

export const {
  useCreateAgendaMutation,
  useGetAgendaByIdQuery,
  useUpdateAgendaMutation,
  useUpdateutilsAgendaMutation,
  useValidateAgendaMutation,
  useLazyGetAgendaByIdQuery,
  useGetAllAgendasBySessionIdApiQuery,
  useLazyGetAllAgendasBySessionIdApiQuery,
  useDeleteAgendaMutation,
  useDeleteAgendaByIdMutation,
  useLazyCloneAgendaQuery,
  useCloneAgendaPostMutation,
  useRescheduleAgendaMutation,
  useRetriggerEmailMutation,
  useCreateAgendaPostPublishMutation
} = AgendaApi;
